import React from "react";
import { format } from "date-fns";

interface DateCellProps {
  date?: string | Date | null;
  formatString?: string;
}

export const DateCell: React.FC<DateCellProps> = ({
  date,
  formatString = "dd.MM.yyyy",
}) => {
  if (!date) return <span></span>;

  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return <div>{format(dateObj, formatString)}</div>;
  } catch (error) {
    return <span>-</span>;
  }
};
